import { Packet } from '@mfro/ts-common/sockets/client';
export const RoomCode = Packet.define();
export const RoomState = Packet.define();
export const StartGameRequest = Packet.define();
export const StartGame = Packet.define();
export const ClientUpdate = Packet.define();
export const BroadcastUpdate = Packet.define();
